/* import __COLOCATED_TEMPLATE__ from './appointment-actions.hbs'; */
import { classNames } from '@ember-decorators/component';
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './appointment-actions.module.scss';

@classic
@classNames('d-flex', 'flex-column', styles.component)
export default class RequestConfirmationAppointmentActions extends Component {
  @service session;
}
